import styled from 'styled-components';
import { BackgroundModal, ModalWrapper } from '../../components/Modal/styles';

export const AuthBackdrop = styled(BackgroundModal)`
    padding-top: 5rem;

    @media (max-width: 750px) {
        & {
            padding-top: 0;
        }
    }
`;

export const AuthContainer = styled(ModalWrapper)`
    max-width: 42.5rem;
    width: calc(100% - 1rem);
    height: 95%;
    max-height: 54.5rem;
    align-self: center;
    border-radius: 1.5rem;
    padding: 1.5rem;
    flex-direction: row;
    gap: 1rem;
    overflow: hidden;

    > div {
        height: 100%;
        flex-basis: 100%;
        max-width: 100%;
        flex-shrink: 0;
        flex: 1;
    }

    .column {
        display: flex;
        height: 100%;
        form {
            margin: auto 0;
        }
    }

    .column-wrapper {
        padding: 0 1rem;
        height: 100%;
        width: 100%;
        overflow: auto;
    }

    button.close-modal-button {
        position: absolute;
        top: 2rem;
        right: 2rem;
        border: none;
        background: none;
        cursor: pointer;

        svg {
            width: 2rem;
            height: 2rem;
        }

        display: none;
    }

    @media (max-width: 750px) {
        & {
            top: 0;
            height: 100%;
            width: 100%;
        }

        .carousel-column {
            display: none;
        }

        > div {
            flex-basis: 100%;
            max-width: 100%;
        }

        button.close-modal-button {
            display: flex;
        }
    }
`;

export const AuthLeftColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    margin: auto;

    form {
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
        justify-content: center;
    }

    .row {
        display: flex;
        gap: 0.5rem;
    }

    .text-inputs-wrapper {
        display: flex;
        flex-direction: column;
        align-items: satretch;
        gap: 1rem;

        .input-item {
            display: flex;
            flex-direction: column;
            gap: 0.25rem;

            label {
                font-size: 1rem;
                font-weight: 600;
                color: var(--Neutral-950, #09090b);
                line-height: 1.5rem;
            }

            input {
                width: 100%;
            }

            span {
                color: var(--Red-400, #e11d48);

                font-size: 0.75rem;
                font-weight: 500;
                line-height: 1rem;
            }

            a.forgot-password {
                color: var(--Silver-500, #999);
                text-align: end;
                font-size: 0.875rem;
                font-weight: 400;
                line-height: 110%;
                cursor: pointer;
                user-select: none;
                width: fit-content;
                margin-left: auto;

                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }
    .phone-row {
        div:first-child {
            min-width: 13rem
        }
    }

    p.api-error {
        color: var(--Red-400, #e11d48);
        font-size: 1rem;
    }

    .error-column {
        display: flex;
        flex-direction: column;
        gap: .5rem;
        text-align: center;
    }

    .login-maintenance-notice {
        text-align: left;
        padding: 0.875rem 1rem;
        border-radius: 0.75rem;
        border: 1px solid var(--Amber-200, #fde68a);
        background: var(--Amber-50, #fffbeb);
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
    }

    .login-maintenance-notice__title {
        margin: 0;
        color: var(--Neutral-900, #18181b);
        font-size: 0.9375rem;
        font-weight: 600;
        line-height: 1.35;
    }

    .login-maintenance-notice__summary {
        margin: 0;
        color: var(--Neutral-700, #3f3f46);
        font-size: 0.8125rem;
        font-weight: 400;
        line-height: 1.35;
    }

    .airplane-icon {
        margin-bottom: 0.5rem;
        align-self: center;
    }

    .title-wrapper {
        display: flex;
        flex-direction: column;
        text-align: center;
        gap: 0.25rem;

        h2.title {
            color: var(--Neutral-900, #18181b);
            font-size: 2rem;
            font-weight: 600;
            line-height: 2.4rem;
        }

        p.description {
            color: var(--Silver-500, #999) !important;
            font-size: 0.875rem;
            font-weight: 400;
            line-height: 1.225rem;
        }

        .foreigner-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 0.5rem;
            margin-top: 0.5rem;

            p {
                color: var(--Neutral-800, #27272a);
                font-size: 0.875rem;
                font-weight: 400;
                height: 1.25rem;
            }
        }
    }

    p.create-account-notice {
        color: var(--Silver-500, #999);
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5rem;
        text-align: center;

        a {
            color: var(--Neutral-900, #18181b);
            font-size: 1rem;
            font-weight: 600;
            line-height: 1.5rem;
            cursor: pointer;
            user-select: none;

            &:hover {
                text-decoration: underline;
            }
        }
    }

    @media (max-width: 750px) {
        & {
            width: 100%;
            max-width: 100% !important;
            flex-basis: 100% !important;
            flex: 1;
        }

        .input-item {
            flex-grow: 1;
        }
    }
`;
